import React from 'react';
import { useIntl } from 'react-intl';

import { useCurrentTheme } from 'app/shared/theme';
import { useIsBreakpointSize } from 'app/shared/utils';
import { City, CityForClp } from 'app/shared/typings';
import { Box, Typography } from 'app/shared/components/atoms';
import { NavigationLink as Link } from 'app/shared/components/atoms';

interface Props {
  invertColors: boolean;
  includeCityNameInTitle: boolean;
  city?: City | CityForClp;
  artistSlug?: string;
  qaId: string;
}

export const Title: React.FC<React.PropsWithChildren<Props>> = ({
  includeCityNameInTitle,
  invertColors,
  city,
  artistSlug,
  qaId,
}) => {
  const { formatMessage } = useIntl();
  const { isMobile } = useIsBreakpointSize();
  const { colors } = useCurrentTheme();

  const textColor = invertColors
    ? colors.primary.white.base
    : colors.primary.black.base;

  if (includeCityNameInTitle && city) {
    return (
      <Box pb={8}>
        <Typography
          lineHeight="100%"
          textTransform="uppercase"
          color={textColor}
        >
          {formatMessage({ id: 'shared.upcomingShowsNear' })}
        </Typography>
        <Link
          href={`/cities/${city.cachedSlug}`}
          data-qaid={`${qaId}-city`}
          variant="primary"
          controlChildSVGStyle={false}
          textDecoration="none"
          fontSize="fontSize700"
          fontFamily="title"
          display="flex"
          flexDirection="row"
          alignItems="baseline"
          gap={3}
          lineHeight="120%"
          w="fit-content"
        >
          {city.title}
        </Link>
      </Box>
    );
  }

  if (isMobile && !artistSlug) {
    return null;
  }

  return (
    <Typography
      pb={8}
      lineHeight="100%"
      fontFamily="title"
      fontSize="fontSize600"
      color={textColor}
    >
      {formatMessage({ id: 'shared.upcomingShows' })}
    </Typography>
  );
};
